import axiosInstance from "../../_utils/axiosConfig";

export const factures = async(page)=>{
    try{
        const response  = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/api/facture`)
        return response.data;
    }catch(error){
        console.log("Erreur lors de l'appel a l'API ",error)
    } 
}